export const COMPLETED_TAG_BACKGROUND_COLOR = '#CEF1D7';
export const COMPLETED_TAG_FONT_COLOR = '#24AF49';
export const PENDING_TAG_BACKGROUND_COLOR = '#FFD585';
export const PENDING_TAG_FONT_COLOR = '#6B4000';
export const OPTIONAL_TAG_BACKGROUND_COLOR = '#BAEEFF';
export const OPTIONAL_TAG_FONT_COLOR = '#266A80';
export const REQUIRED_TAG_BACKGROUND_COLOR = '#FFDBDB';
export const REQUIRED_TAG_FONT_COLOR = '#C65858';
